import { Box, Flex } from '@chakra-ui/react';
import { Heading, Text, VStack } from 'components/ui';
import { GradientButton } from './GradientButton';
import { useAffiliate } from '../../../../api/affiliates/useAffiliate';
import {
  AffiliateCareModel,
  AffiliateType,
} from '../../../../models/affiliate';
import { TRACKING_LANDING_PAGE_CTA } from '../../../OnboardingForm/constants';

const features = (affiliate) => [
  {
    number: 1,
    title: 'Book your initial video visit',
    description:
      affiliate?.care_model === AffiliateCareModel.coachOnly
        ? 'Meet your coach to discuss your gut health goals in a comprehensive welcome visit.'
        : 'Meet your Ayble provider to discuss your gut health goals in a comprehensive welcome visit.',
  },
  {
    number: 2,
    title: 'Get a personalized plan',
    description:
      affiliate?.care_model === AffiliateCareModel.collaborative &&
      affiliate?.affiliate_type === AffiliateType.healthPlan
        ? 'Tailored diet guidance, stress tools, medication, supplements, and more.'
        : 'Tackle your symptoms with nutrition coaching, gut-brain trainings, & more!',
  },
  {
    number: 3,
    title: '24/7 ongoing support',
    description:
      'Unlimited virtual visits and messaging when you need extra motivation, support, or answers.',
  },
];

export const HowItWorks = ({ onStartOnboarding }) => {
  const { affiliate } = useAffiliate();
  return (
    <Box px={4} py={{ base: 12, lg: 20 }} maxW="1200px" mx="auto">
      <VStack gap={6} alignItems="center">
        <Text
          borderWidth={1}
          borderColor="#718F9A"
          px={4}
          py={2}
          borderRadius="full"
          fontSize="sm"
          fontWeight={500}
          color="#718F9A"
        >
          How It Works
        </Text>

        <Heading
          color={'secondary.500'}
          textAlign="center"
          fontSize={'4xl'}
          fontWeight={400}
          maxW={{ base: '90%', lg: '100%' }}
        >
          Care That Covers Digestive Needs
        </Heading>

        <Flex direction={{ base: 'column', lg: 'row' }} gap={4} mb={12}>
          {features(affiliate).map(({ number, title, description }) => (
            <VStack
              gap={3}
              flex={1}
              key={title}
              p={5}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Box
                backgroundColor={'#BCC7D7'}
                borderColor={'#E7E7E7'}
                borderWidth={1}
                rounded={'full'}
                w={33}
                h={33}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Text fontWeight={'bold'}>{number}</Text>
              </Box>
              <Heading
                textAlign={'left'}
                fontWeight={400}
                fontSize="2xl"
                color="secondary.600"
              >
                {title}
              </Heading>
              <Text
                fontSize="16px"
                color="secondary.200"
                mt={1}
                maxW={'90%'}
                textAlign={'center'}
              >
                {description}
              </Text>
            </VStack>
          ))}
        </Flex>
        <Box w={{ base: '100%', lg: '342px' }}>
          <GradientButton
            onPress={() => onStartOnboarding(TRACKING_LANDING_PAGE_CTA)}
          >
            Book Your First Visit →
          </GradientButton>
        </Box>
      </VStack>
    </Box>
  );
};
